export default "__VITE_ASSET__603c29e6__"